export default function(){
    jQuery('.profile-sidebar').each(function(){
        setTimeout(function(){
            if(window.location.hash == '#promocodes') {
                jQuery('a[href="#tab-four"]').trigger('click');
            }
        }, 800);
    });
}